import React, { Component } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
//Import Images
import feature1 from "../../assets/images/features/feature-1.jpg";
import feature2 from "../../assets/images/features/feature-2.png";
import feature3 from "../../assets/images/features/feature-3.jpg";
import feature4 from "../../assets/images/features/feature-4.png";
//Import Section Title
import SectionTitle from "../common/section-title";
import FeatureBox from "./feature-box";

class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smallFeatures1: [
        { title: "Donec quam felis" },
        { title: "Ultricies nec" },
      ],
      smallFeatures2: [
        { title: "Donec quam felis" },
        { title: "Ultricies nec" },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section className="section" id="features">
          <Container>
            <SectionTitle subtitle="Key Features" title="With Agari you can" />

            <Row>
              <Col lg={5}>
                <div>
                  <FeatureBox
                    icon="heart"
                    title="Donate For Campaigns"
                    desc="Donate for the campaign of your choice and keep track of it in real-time"
                    link="#"
                  />
                </div>
              </Col>

              <Col lg={5} sm={8} className="ml-lg-auto">
                <Card className="border border-light shadow-none mt-5 mt-lg-0">
                  <CardHeader className="border-0 bg-transparent">
                    <div>
                      <i className="mdi mdi-circle text-danger mr-1"></i>
                      <i className="mdi mdi-circle text-warning mr-1 ml-1"></i>
                      <i className="mdi mdi-circle text-success mr-1 ml-1"></i>
                    </div>
                  </CardHeader>
                  <CardBody className="bg-light">
                    <div className="box-shadow">
                      <img
                        src={feature1}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mt-5 pt-5">
              <Col lg={5} sm={8}>
                <Card className="border border-light shadow-none">
                  <CardHeader className=" border-0 bg-transparent">
                    <div>
                      <i className="mdi mdi-circle text-danger mr-1"></i>
                      <i className="mdi mdi-circle text-warning mr-1 ml-1"></i>
                      <i className="mdi mdi-circle text-success mr-1 ml-1"></i>
                    </div>
                  </CardHeader>
                  <CardBody className="bg-light">
                    <div className="box-shadow">
                      <img
                        src={feature2}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={5} className="ml-lg-auto">
                <div className="mt-4 mt-lg-0">
                  <FeatureBox
                    icon="edit"
                    title="Create Campaigns"
                    desc=" Describe your fundraising cause and the amount you hope to raise"
                    link="#"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <div>
                  <FeatureBox
                    icon="share-2"
                    title="Share the news"
                    desc="Go viral by sharing campaigns through our social media tools"
                    link="#"
                  />
                </div>
              </Col>

              <Col lg={5} sm={8} className="ml-lg-auto">
                <Card className="border border-light shadow-none mt-5 mt-lg-0">
                  <CardHeader className="border-0 bg-transparent">
                    <div>
                      <i className="mdi mdi-circle text-danger mr-1"></i>
                      <i className="mdi mdi-circle text-warning mr-1 ml-1"></i>
                      <i className="mdi mdi-circle text-success mr-1 ml-1"></i>
                    </div>
                  </CardHeader>
                  <CardBody className="bg-light">
                    <div className="box-shadow">
                      <img
                        src={feature3}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mt-5 pt-5">
              <Col lg={5} sm={8}>
                <Card className="border border-light shadow-none">
                  <CardHeader className=" border-0 bg-transparent">
                    <div>
                      <i className="mdi mdi-circle text-danger mr-1"></i>
                      <i className="mdi mdi-circle text-warning mr-1 ml-1"></i>
                      <i className="mdi mdi-circle text-success mr-1 ml-1"></i>
                    </div>
                  </CardHeader>
                  <CardBody className="bg-light">
                    <div className="box-shadow">
                      <img
                        src={feature4}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={5} className="ml-lg-auto">
                <div className="mt-4 mt-lg-0">
                  <FeatureBox
                    icon="pie-chart"
                    title="Manage and receive donations"
                    desc="Create and follow up your fundraising campaigns using our campaign managment tools
                    "
                    link="#"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Features;
